import { 
    RequestActionTypes,
    RequestState, 
    RequestActions,
} from "./request.types";

const INITIAL_STATE: RequestState = {
    message: null,
    isFetching: false,
    requestErrorMessage: null,
};

const requestReducer = (state: any = INITIAL_STATE, action: RequestActions) => {
    switch (action.type) {
        case RequestActionTypes.FETCH_REQUEST_START:
            return {
                ...state,
                isFetching: true,
            };
        case RequestActionTypes.FETCH_REQUEST_SUCCESS:
            return {
                ...state,
                isFetching: false,
                message: action.payload.message
            };
        case RequestActionTypes.FETCH_REQUEST_FAILURE:
            return {
                ...state,
                isFetching: false,
                requestErrorMessage: action.payload.errorMessage
            };
        default:
            return state;
    }
};

export default requestReducer;
